export default __webpack_public_path__ + "static/summer_containers31-94788240b4d9c8315db57a9a326f15fe.webp";